import React, {Component} from 'react';
import UserService from "../../services/UserService";

class NotFound extends Component {

  constructor(props) {
    super(props);
    this.state = {currentUser: UserService.currentUser};
  }

  render() {
    return <h2>Entidate não encontrada</h2>
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/component/NotFound/NotFound.js